import styled from 'styled-components';

export const Container = styled.div`
  width: 1000px;
  min-height: calc(100vh - 90px);

  background: #FFFFFF;
  mix-blend-mode: normal;
  box-shadow: 0px 0.25rem 0.25rem rgba(0, 0, 0, 0.25);

  margin: 0 auto;
  padding: 1.25rem 3.125rem;

  input {
    width: 190px;
  }

  input[type=time] {
    padding-right: 0.313rem;
  }

  @media screen and (max-width: 679px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  margin-top: 2.188rem;

  small {
    display: block;

    font: 400 italic 0.75rem/1.3 "Lato", serif;
    text-align: right;
  }
`;

export const WrapperItems = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;